import { Injectable, Provider, effect, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AtomFilterPanelIntl } from "@atomchat-io/ui-design-system";
import { TranslocoService } from "@jsverse/transloco";
import { take } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class AtomFilterPanelConfigService extends AtomFilterPanelIntl {
    private readonly translocoService = inject(TranslocoService);
    private readonly activeLang = toSignal(this.translocoService.langChanges$);

    constructor() {
        super();
        effect(() => {
            this.activeLang();
            this.updateLabels();
        });
    }

    // Both overrides read the active language through the imperative
    // `translate`, the only shape the design system accepts: it types them as
    // pure functions returning a string, so there is nothing to subscribe to.
    // The catalog is already loaded by the time the panel renders — the
    // `updateLabels()` effect below awaits the same object.
    override getCategoryTitle(category: string): string {
        return this.translocoService.translate(
            "atom_filter_panel.category_title",
            { category },
        );
    }

    override getCounterLabel(selected: number, total: number): string {
        return this.translocoService.translate(
            "atom_filter_panel.count_pattern",
            { selected, total },
        );
    }

    private updateLabels(): void {
        this.translocoService
            .selectTranslateObject("atom_filter_panel")
            .pipe(take(1))
            .subscribe((data) => {
                this.clearAllLabel = data.clear_all_label;
                this.clearCategoryLabel = data.clear_category_label;
                this.categoriesLabel = data.categories_label;
                this.dialogLabel = data.dialog_label;
                this.changes.next();
            });
    }
}

export const provideAtomFilterPanelConfig = (): Provider => ({
    provide: AtomFilterPanelIntl,
    useExisting: AtomFilterPanelConfigService,
});
